// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1UmSb","buttons":"Footer_buttons__1g32Z"};